import React, { useEffect, useState } from "react";
import { Col, Row, Space, Typography, Table } from "antd";
import { pgp2Columns } from "./config";
import { useAppSelector } from "redux/hooks";
import { infoDetailsProps } from "types/models/infoDetailsProps";
import { data4Col } from "../../config";
import { optionsTypeLens } from "types/config/glasses-prescription ";

const Pgp2Print = ({data}) => {
  
  const [dataPgp2Print, setDataPgp2Print] = useState({
    left: data4Col,
    right: data4Col,
  });

  useEffect(() => {
    if (
      data &&
      data?.left &&
      (data?.left?.sph ||
        data?.left?.cyl ||
        data?.left?.axis ||
        data?.left?.vision)
    ) {
      setDataPgp2Print((pre) => ({
        ...pre,
        left: [
          {
            key: 1,
            none: "Xa",
            sph: data?.left?.sph && data?.left?.sph[0],
            cyl: data?.left?.cyl && data?.left?.cyl[0],
            axis: data?.left?.axis && data?.left?.axis[0],
            vision: data?.left?.vision && data?.left?.vision[0],
          },
          {
            key: 2,
            none: "Add",
            sph: data?.left?.sph && data?.left?.sph[1],

            cyl: data?.left?.cyl && data?.left?.cyl[1],
            axis: data?.left?.axis && data?.left?.axis[1],
            vision: data?.left?.vision && data?.left?.vision[1],
          },
          {
            key: 3,
            none: "Gần",
            sph: data?.left?.sph && data?.left?.sph[2],
            cyl: data?.left?.cyl && data?.left?.cyl[2],
            axis: data?.left?.axis && data?.left?.axis[2],
            vision: data?.left?.vision && data?.left?.vision[2],
          },
        ],
      }));
    }else {
      setDataPgp2Print((pre) => ({
        ...pre,
        left: data4Col,
      }));
    }

    if (
      data &&
      data?.right &&
      data?.right?.sph &&
      (data?.right?.sph ||
        data?.right?.cyl ||
        data?.right?.axis ||
        data?.right?.vision)
    ) {
      setDataPgp2Print((pre) => ({
        ...pre,
        right: [
          {
            key: 1,
            none: "Xa",
            sph: data?.right?.sph && data?.right?.sph[0],
            cyl: data?.right?.cyl && data?.right?.cyl[0],
            axis: data?.right?.axis && data?.right?.axis[0],
            vision: data?.right?.vision && data?.right?.vision[0],
          },
          {
            key: 2,
            none: "Add",
            sph: data?.right?.sph && data?.right?.sph[1],
            cyl: data?.right?.cyl && data?.right?.cyl[1],
            axis: data?.right?.axis && data?.right?.axis[1],
            vision: data?.right?.vision && data?.right?.vision[1],
          },
          {
            key: 3,
            none: "Gần",
            sph: data?.right?.sph && data?.right?.sph[2],
            cyl: data?.right?.cyl && data?.right?.cyl[2],
            axis: data?.right?.axis && data?.right?.axis[2],
            vision: data?.right?.vision && data?.right?.vision[2],
          },
        ],
      }));
    }else {
      setDataPgp2Print((pre) => ({
        ...pre,
        right: data4Col,
      }));
    }
   
  }, [data]);

  const value = [
    {
      key: 1,
      data: dataPgp2Print.right,
      
      typeOfLens: (data?.right && data?.right?.select) || null,
      comment: (data?.right && data?.right?.comments) || null,
    },
    {
      key: 2,
      data: dataPgp2Print.left,
      
      typeOfLens: (data?.left && data?.left?.select) || null,
      comment: (data?.left && data?.left?.comments) || "",
    },
  ];
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Row gutter={[16, 8]}>
        {value.map((item) => {
          const res = optionsTypeLens.find((e) => {
            if (e.value === item.typeOfLens) {
              return e.label;
            }
          });

          return (
            <Col span={12} key={item.key}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Typography.Text style={{ fontWeight: "bold" }}>
                  Kính đang đeo 2:
                </Typography.Text>
                <Table
           
                  dataSource={item.data}
                  columns={pgp2Columns}
                  bordered={true}
                  pagination={false}
                  className="table-print"

                />
                {item.typeOfLens && (
                  <Row>
                    <Typography className="title-print"
                      style={{ paddingRight: "8px" }}
                      >
                      Loại mắt kính:
                    </Typography>
                    <Typography.Text >
                      {res?.label}
                    </Typography.Text>
                  </Row>
                )}
                {item.comment && (
                  <Row>
                    <Typography className="title-print"
                      style={{ paddingRight: "8px" }}
                      >Nhận xét:</Typography>
                    <Typography.Text >
                      {item.comment}
                    </Typography.Text>
                  </Row>
                )}
              </Space>
            </Col>
          );
        })}
      </Row>
    </Space>
  );
};

export default Pgp2Print;
